import { ref } from 'vue'
import type { CockpitOps } from '@/types/cockpit'
import { fetchCockpitOps } from '@/api/cockpit'

export function useCockpitOps() {
  const ops = ref<CockpitOps | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function fetch(): Promise<void> {
    loading.value = true
    error.value = null
    try {
      ops.value = await fetchCockpitOps()
    } catch {
      error.value = 'admin.cockpit.ops.error'
    } finally {
      loading.value = false
    }
  }

  return { ops, loading, error, fetch }
}
